import { useResolutions } from 'store/resolutions'
import { useIntl } from 'react-intl'
import DesktopSection from './components/DesktopSection'
import MobileSection from './components/MobileSection'
import { ContentWrapper } from './styles'
import Modal from 'components/shared/Modal'
import { useApp } from 'store/steps'
import { useListOpeningHoursQuery } from 'store/api-slice/hooks'
import Loader from 'components/shared/Loader'
import { useMemo } from 'react'
import Box from 'components/shared/Box'

interface DifferentHoursProps {
    isOpened: boolean
    close: () => void
}

const OpeningHoursModal = ({ isOpened, close }: DifferentHoursProps) => {
    const { formatMessage } = useIntl()
    const { isMobile, isSmallTablet } = useResolutions()
    const { language } = useApp()
    const { isFetching, data } = useListOpeningHoursQuery(
        { _locale: language },
        { skip: !isOpened }
    )
    const seasons = data?.items

    const getOpeningHoursByResolution = useMemo(() => {
        if (seasons && seasons.length) {
            if (isMobile || isSmallTablet) {
                return <MobileSection seasons={seasons} />
            }
            return <DesktopSection seasons={seasons} />
        }
        return null
    }, [seasons, isMobile, isSmallTablet])

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={1170}
            onClose={close}
            isMobileFullscreen
            testIdPrefix="opening-hours"
            hasGlobalHeader
            headerMessage={formatMessage({
                id: 'global.modal.opening_hours_title',
                defaultMessage: 'Godziny otwarcia',
            })}
        >
            <ContentWrapper isFullWidth={true}>
                <Box
                    pt={[18, 36]}
                    pr={[16, 40]}
                    pb={[36, 40]}
                    pl={[16, 40]}
                    isFullWidth={true}
                    align="center"
                >
                    {isFetching ? (
                        <Loader
                            pt={[22, 42]}
                            pb={[22, 42]}
                            justify="center"
                            align="center"
                        />
                    ) : (
                        getOpeningHoursByResolution
                    )}
                </Box>
            </ContentWrapper>
        </Modal>
    )
}

export default OpeningHoursModal
